import { v4 as uuid } from 'uuid';
import { Platform } from 'lib/app/platform';

const DW_LOCAL_STORAGE_KEY = 'hpSessionUuid';
const MW_LOCAL_STORAGE_KEY = 'hotpanel_session';

const HOTPANEL_SESSION_TTL = 5 * 60 * 1000;

type MwHotpanelSessionData = {
    updateTs: number;
    uuid: string;
};

type DwHotpanelSessionData = {
    ts: number;
    uid: string;
};

function getSessionObject<T>(storageKey: string) {
    try {
        const sessionString = window.localStorage.getItem(storageKey);
        if (sessionString) {
            return JSON.parse(sessionString) as T;
        }
    } catch (error) {
        // Hotpanel session can't be loaded from session storage, ignore error
    }

    return undefined;
}

function getNormalizedSessionData(platform: Platform | undefined) {
    if (platform === Platform.DESKTOP_WEB) {
        const data = getSessionObject<DwHotpanelSessionData>(DW_LOCAL_STORAGE_KEY);
        return { sessionId: data?.uid, ts: data?.ts };
    }

    const data = getSessionObject<MwHotpanelSessionData>(MW_LOCAL_STORAGE_KEY);
    return { sessionId: data?.uuid, ts: data?.updateTs };
}

function storeSessionData(sessionId: string, platform: Platform | undefined) {
    if (platform === Platform.DESKTOP_WEB) {
        window.localStorage.setItem(
            DW_LOCAL_STORAGE_KEY,
            JSON.stringify({
                uid: sessionId,
                ts: Date.now(),
            } as DwHotpanelSessionData)
        );
        return;
    }

    window.localStorage.setItem(
        MW_LOCAL_STORAGE_KEY,
        JSON.stringify({
            uuid: sessionId,
            updateTs: Date.now(),
        } as MwHotpanelSessionData)
    );
}

export function getHotpanelSession(platform: Platform | undefined) {
    let { sessionId, ts } = getNormalizedSessionData(platform);
    if (!sessionId || !ts || ts + HOTPANEL_SESSION_TTL < Date.now()) {
        sessionId = uuid();
    }

    storeSessionData(sessionId, platform);

    return sessionId;
}
